import { ContactInformationData } from './contact-information-data';

export interface SalesOfficeContactData {
  countryCode: string;
  salesOfficeCode: string;
  salesOfficeGroup: string;
  contacts: Array<ContactInformationData>;
}
